


























































import { Component, Inject } from "vue-property-decorator";
import {
  ICProdsProviderData,
  ICProdsProviderMethods
} from "@/models/providers/contractProduct";
import Context from "@/mixins/context";

@Component({
  components: {
    "cprod-well-link": () =>
      import("@/components/app/global/contractProducts/cProdWellLink.vue")
  }
})
export default class CProdsGridView extends Context {
  // Inject
  @Inject({ from: "cProdsProvider" })
  public cProdsProvider!: () => ICProdsProviderData;

  @Inject({ from: "cProdsProviderMethods" })
  public $cProdsMethods!: ICProdsProviderMethods;

  public get $cProdsData() {
    return this.cProdsProvider();
  }

  public get showCta() {
    return this.$store.getters["brand/showStore"] && !this.isMockClientContext;
  }

  public makeNewOrder() {
    if (this.isAdmin) {
      this.$store.dispatch("data/contracts/startNewOrder");
    } else {
      this.$router.push({ name: "order" });
    }
  }
}
